import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { formatWithCommas } from "../../assets/helpers";

const { Text } = Typography;

const SummaryCard = ({data={}, loading=false}) => {


  const items = [
    {
      label: "Total PTP Amount",
      value: formatWithCommas(data?.total_ptp_amount),
    },
    {
      label: "Amount Collected",
      value: formatWithCommas(data?.amount_collected),
    },
    {
      label: "Callback PTP",
      value: `${data.callback_to_ptp_conversion_percentage || 0}%`,
    },
    {
      label: "PTP Paid",
      value: `${data.ptp_to_paid_conversion_percentage || 0}%`,
    },
  ];

  return (
    <Card
      style={{
        borderRadius: 12,
        padding: 10,
      }}
      loading={loading}
    >
      <Row gutter={[16, 16]}>
        {items.map((item, index) => (
          <Col span={12} key={index}>
            <div>
              <Text type="secondary">{item.label}</Text>
              <br />
              <Text strong style={{ fontSize: 16 }}>
                {item.value}
              </Text>
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default SummaryCard;